// extracted by mini-css-extract-plugin
export var closeButton = "_hy-1";
export var closeX = "_hy-3";
export var container = "_hy-0";
export var image = "_hy-2";